import z from "zod";

const translationPath = "chatBot.page.service.banList.errors.";

const ticketServiceSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    enable: z.boolean(),
  },
  { invalid_type_error: translationPath + "ticket_service" },
);

export const banListSchema = z.object({
  id: z.string().optional(),
  ticketService: ticketServiceSchema,
  phoneNumber: z
    .string()
    .min(1, translationPath + "phone_number")
    .regex(/^[0-9]+$/, translationPath + "only_phone_numbers"),
  observation: z.string().optional(),
});

export type TBanListForm = z.infer<typeof banListSchema>;
